// Session sampling when VITE_FARO_SAMPLE_RATE is unset or invalid. Sampling is the main cost
// lever (spec §7.5); set the real rate per environment.
export const DEFAULT_SAMPLE_RATE = 0.1;

export interface FaroOptions {
  url: string;
  // The Grafana Frontend Observability app, one per environment: email-login-{dev,stage,prod}.
  appName: string;
  environment: string;
  version: string;
  sampleRate: number;
}

// Each pairs with one Grafana app, so a missing value disables Faro rather than falling back to
// another environment's name.
const REQUIRED_KEYS = [
  "VITE_FARO_COLLECTOR_URL",
  "VITE_FARO_APP_NAME",
  "VITE_FARO_APP_ENVIRONMENT",
] as const;

const parseSampleRate = (value: string | undefined) => {
  const rate = Number(value);
  return value && Number.isFinite(rate) && rate >= 0 && rate <= 1 ? rate : DEFAULT_SAMPLE_RATE;
};

export const getFaroOptions = (env: ImportMetaEnv = import.meta.env): FaroOptions | undefined => {
  if (env.VITE_ANALYTICS_ENABLED !== "true" || env.VITE_FARO_ENABLED !== "true") {
    return undefined;
  }
  const missing = REQUIRED_KEYS.filter((key) => !env[key]);
  if (missing.length > 0) {
    console.warn(`VITE_FARO_ENABLED is true but ${missing.join(", ")} not set; Faro is disabled`);
    return undefined;
  }
  return {
    url: env.VITE_FARO_COLLECTOR_URL!,
    appName: env.VITE_FARO_APP_NAME!,
    environment: env.VITE_FARO_APP_ENVIRONMENT!,
    version: env.VITE_ANALYTICS_VERSION || "dev",
    sampleRate: parseSampleRate(env.VITE_FARO_SAMPLE_RATE),
  };
};
